import Axios from 'axios'
import {facilityTypeUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_facility_types (context) {
    Axios.get(facilityTypeUrls.getAllFacilityTypes).then(function (response) {
     
      context.commit('GET_ALL_FACILITY_TYPES', response.data)
    })
  },
  get_facility_types (context, publicId) {
    Axios.get(facilityTypeUrls.getFacilityTypes + publicId).then(function (response) {
      context.commit('GET_FACILITY_TYPES', response.data)
    })
  },
  get_deleted_facility_types (context) {
    Axios.get(facilityTypeUrls.getDeletedFacilityType).then(function (response) {
      context.commit('GET_DELETED_FACILITY_TYPES', response.data)
    })
  },
  get_facility_type (context, publicId) {
    Axios.get(facilityTypeUrls.getFacilityType + publicId).then(function (response) {
      context.commit('GET_FACILITY_TYPE', response.data)
    })
  },
  post_facility_type (context, data) {
    Axios.post(facilityTypeUrls.postFacilityType, data).then(function () {
      context.dispatch('get_all_facility_types')
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  update_facility_type (context, data) {
    Axios.post(facilityTypeUrls.editFacilityType + data.public_id, data).then(function () {
      context.dispatch('get_all_facility_types')
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_facility_type (context, data) {
    Axios.post(facilityTypeUrls.deleteFacilityType + data.public_id, data).then(function (response) {
      context.dispatch('get_all_facility_types')
    })
  },
  restoreFacilityType (context, publicId) {
    Axios.get(facilityTypeUrls.restoreFacilityType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_FACILITY_TYPES', response.data)
      router.push({
        name: 'Module.FacilityTypes'
      })
    })
  }
}
